import { isEqual } from 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const normalizeNodesIds = (nodes) => {
  let i = 0;
  const normalizeIds = (nodes2) => {
    if (nodes2.length === 0) {
      return [];
    }
    return nodes2.map((node) => {
      const _a = node, { id: _, nodes: nodes3 } = _a, rest = __objRest(_a, ["id", "nodes"]);
      return __spreadProps(__spreadValues({}, rest), {
        id: `${i++}`,
        nodes: normalizeIds(nodes3)
      });
    });
  };
  return normalizeIds(nodes);
};
const isRichContentEqual = (a = { nodes: [] }, b = { nodes: [] }) => {
  const aNormalized = JSON.parse(JSON.stringify(a));
  const bNormalized = JSON.parse(JSON.stringify(b));
  if (!isEqual(aNormalized.documentStyle, bNormalized.documentStyle)) {
    return false;
  }
  if (aNormalized.nodes.length !== bNormalized.nodes.length) {
    return false;
  }
  const aNodes = normalizeNodesIds(aNormalized.nodes);
  const bNodes = normalizeNodesIds(bNormalized.nodes);
  if (!isEqual(aNodes, bNodes)) {
    return false;
  }
  return true;
};

export { isRichContentEqual };
